import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import {
  IAppleDepApiLog,
  IAppleDepDealerSettings,
  IAppleDepShowOrderDetailsResponse,
} from '../models/models'
import {
  IAppleDepDevice,
  IAppleDepDeviceFilter,
  IAppleDepSendResult,
  IAppleDepTransaction,
  IAppleDepTransactionFilter,
} from '../../../MySpecial/AppleDep/models/models'

/**
 * Bayi bazlı Apple DEP ayarları (Organization ID kaynağı, bayinin kendi ABM bilgisi).
 * Reseller ID buraya dahil değildir — tek değerdir ve appsettings'ten gelir.
 */
export class AdminGetDealerSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/AdminGetDealerSettings', requesterInfo })
  }

  public async getDealerSettings(search?: string): Promise<IAppleDepDealerSettings[]> {
    return await this.postAsync<IAppleDepDealerSettings[]>({ Search: search ?? '' })
  }
}

export class AdminSaveDealerSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/AdminSaveDealerSettings', requesterInfo })
  }

  public async saveDealerSettings(request: IAppleDepDealerSettings): Promise<{ Id: number }> {
    return await this.postAsync<{ Id: number }>(request)
  }
}

export class AdminDeleteDealerSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/AdminDeleteDealerSettings', requesterInfo })
  }

  public async deleteDealerSettings(id: number): Promise<boolean> {
    return await this.postAsync<boolean>({ Id: id })
  }
}

/**
 * Index admin, herhangi bir bayi adına gönderim yapar. RE (iade), OV (düzeltme) ve
 * VD (iptal) yalnızca bu uç üzerinden kullanılabilir — Apple bu tiplere erişimin
 * kısıtlı ve eğitimli bir ekipte olmasını şart koşuyor.
 */
export class AdminSendToAppleApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/AdminSendToApple', requesterInfo })
  }

  public async sendToApple(request: {
    DeviceIds: number[]
    OrderType: string
    DealerCode: string
  }): Promise<IAppleDepSendResult> {
    return await this.postAsync<IAppleDepSendResult>(request)
  }
}

/** Apple eskalasyonlarında zorunlu olan ham JSON istek/yanıt kayıtları. */
export class AdminGetApiLogsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/AdminGetApiLogs', requesterInfo })
  }

  public async getApiLogs(transactionRowId: number): Promise<IAppleDepApiLog[]> {
    return await this.postAsync<IAppleDepApiLog[]>({ Id: transactionRowId })
  }
}

/** Admin, bayi kodu vererek o bayinin cihazlarını görebilir. */
export class AdminGetDevicesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/GetDevices', requesterInfo })
  }

  public async getDevices(request: IAppleDepDeviceFilter & { DealerCode: string }): Promise<IAppleDepDevice[]> {
    return await this.postAsync<IAppleDepDevice[]>(request)
  }
}

/** Bayi kodu boş bırakılırsa tüm bayilerin gönderimleri döner. */
export class AdminGetTransactionsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/GetTransactions', requesterInfo })
  }

  public async getTransactions(
    request: IAppleDepTransactionFilter & { DealerCode?: string }
  ): Promise<IAppleDepTransaction[]> {
    return await this.postAsync<IAppleDepTransaction[]>(request)
  }
}

/** Apple'da o an kayıtlı cihazları sipariş numarasına göre sorgular (denetim). */
export class AdminShowOrderDetailsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'AppleDep/ShowOrderDetails', requesterInfo })
  }

  public async showOrderDetails(request: {
    OrderNumbers: string[]
    DealerCode: string
  }): Promise<IAppleDepShowOrderDetailsResponse> {
    return await this.postAsync<IAppleDepShowOrderDetailsResponse>(request)
  }
}
